export const widgetsGroups = [
    {
        id: 'status',
        name: 'Status',
    },
    {
        id: 'costs',
        name: 'Costs',
    },
];
export const widgetsList = [
    {
        id: 'episodeStatus',
        defaultName: 'Episode status',
        type: 'episodeStatus',
        groupId: 'status',
        description: 'A widget that provides a quick overview of an episode’s progress across selected key production steps. It displays a graphical representation of asset statuses, along with deadlines and completion percentages. Breakdown links between the episode and models are used to list relevant elements, while parent-child relationships define shot components.',
    },
    {
        id: 'episodeCosts',
        defaultName: 'Episode costs',
        type: 'episodeCosts',
        groupId: 'costs',
        description: 'This widget provides a cost summary for an episode, focusing on selected production steps. It highlights any deviations from your initial cost assumptions for the relevant assets and offers a forecast of future costs based on your production data and our predictive model.',
    },
    {
        id: 'globalStatus',
        defaultName: 'Global status',
        type: 'globalStatus',
        groupId: 'status',
        description: "Quick overview of your project’s advancement across major chosen production steps. It shows how many episodes are in “To Do,” “In Progress,” or “Done” status, depending on the status of their children's tasks.",
    },
    {
        id: 'globalCosts',
        defaultName: 'Global costs',
        type: 'globalCosts',
        groupId: 'costs',
        description: 'Cost summary for your entire project, focused on selected steps. Highlights potential deviations from your planned cost assumptions. Provides a projection of future costs based on our model and your production data.',
    },
];
